import { FC } from "react";
import { useTranslation } from "react-i18next";

import { LandingLayout, LoaderMuiLanding } from "@ryde/controls-landing";
import {
  CompanyScopeLandingsContextWrapper,
  ILandingPage,
  LandingCompanyIdEnum,
  useLandingInit,
} from "@ryde/utils-landings";

import { ClalWrapper } from "./clal-wrapper.styled";

export const ClalPage: FC<ILandingPage> = ({ companyId }) => {
  const { t } = useTranslation();
  const { landingInitData, isLoading } = useLandingInit({ companyId });
  return (
    <>
      {landingInitData && (
        <CompanyScopeLandingsContextWrapper
          companyId={landingInitData.companyId}
        >
          <ClalWrapper>
            <LandingLayout stepsContainerId={LandingCompanyIdEnum.Clal} />
          </ClalWrapper>
        </CompanyScopeLandingsContextWrapper>
      )}
      {isLoading && <LoaderMuiLanding loading text={t("ui.LOADING_DATA")} />}
    </>
  );
};
